import HotelConstants from 'arbitrip-common/client/constants/HotelConstants';

export default HotelConstants;
